import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";

const mapStateToProps = (state) => {
    return {
        portfolioMarket: state.jarvisPrime.primeDashboard.portfolioMarket,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPortfolioMarketAction: jarvisPrimeDashboardActions.getPortfolioMarket
}, dispatch)

const MarketCapDiversificationStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default MarketCapDiversificationStore;